import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';
const StepSnowSportsShared = () => (
  <ol>
    <li>
      <FormattedMessage {...messages.document1} />
    </li>
    <li>
      <FormattedMessage {...messages.document2} />
    </li>
    <li>
      <FormattedMessage {...messages.document3} />
    </li>
    <li>
      <FormattedMessage {...messages.document4} />
    </li>
    <li>
      <FormattedMessage {...messages.document5} />
    </li>
    <li>
      <FormattedMessage {...messages.document6} />
    </li>
  </ol>
);

export default StepSnowSportsShared;



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepSnowSports/components/StepSnowSportsShared.js